import { useRef } from 'react'

/**
 * Returns a ref that always holds the latest value.
 * Useful for accessing up-to-date values in callbacks/effects
 * without adding them to dependency arrays.
 */
export function useLatestRef<T>(value: T) {
  const ref = useRef(value)
  ref.current = value
  return ref
}
